export default "__VITE_ASSET__CITYFE_Q__"